import { render, staticRenderFns } from "./LineChart2.vue?vue&type=template&id=37ac88c1&scoped=true"
import script from "./LineChart2.vue?vue&type=script&lang=js"
export * from "./LineChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac88c1",
  null
  
)

export default component.exports